const exercises = [
  {
  title:'Scales',
  description:'These scales follow the cycle of fifths to go up, while never shifting and always keeping the same fingering. After a while, you will feel that every position is as comfortable. The number on the right is the current pattern you are playing. You will see that there are only 7 different patterns. While practicing, try always to remember which pattern you are playing, and to feel the tonality you are in.',
  kind:1,
  extension:false,
  exercises:[
  
{
  id:4,
  title:'Scales on 2 strings',
  description:'G, D'
},
{
  id:5,
  title:'Scales on 2 strings',
  description:'D, A'
},
{
  id:6,
  title:'Scales on 2 strings',
  description:'A, E'
}],
  },
{
  title:'Thirds scales',
  description:'These scales allow you to practice shifts, while having a feeling of the position you are in. They also follow the cycle of fifths to go up, which allows you to cover all tonalities in every position. Don\'t forget to keep an eye on the pattern you are playing and the tonality you are in.',
  kind:1,
  extension:false,
  exercises:[
{
  id:19,
  title:'Thirds on 3 strings',
  description:'G, D, A'
},
{
  id:20,
  title:'Thirds on 3 strings',
  description:'D, A, E'
},
  ]
},
  {
  title:'Sixths scales',
  description:'',
  kind:1,
  extension:false,
  exercises:[
{
  id:21,
  title:'Sixths on 3 strings',
  description:'G, D, A'
},
{
  id:22,
  title:'Sixths on 3 strings',
  description:'D, A, E'
},
  ]
},
  {
  title:'Octaves scales',
  description:'These scales allow you to practice shifts, while having a feeling of the position you are in. Octave is the basic frame that lets you feel the fingerboard getting smaller while you go up. It is also the most perfect interval, so no excuse for intonation ! They also follow the cycle of fifths to go up, which allows you to cover all tonalities in every position. Don\'t forget to keep an eye on the pattern you are playing and the tonality you are in.',
  kind:1,
  extension:false,
  exercises:[
{
  id:23,
  title:'Octaves on 3 strings',
  description:'G, D, A'
},
{
  id:24,
  title:'Octaves on 3 strings',
  description:'D, A, E'
},
  ]
},
{
  title:'Double-stops patterns',
  description:'This exercise allows you to develop a feeling of patterns withing any position. It make you connect notes together, develops a feeling of position, and allows intonation improvement by making you repeat the same motions. Keep an eye on the number on the right, which shows which pattern you are currently working on, and don\'t forget what tonality you are in.',
  kind:2,
  extension:false,
  exercises:[
{
  id:7,
  title:'Double-stops patterns',
  description:'G, D'
},
{
  id:8,
  title:'Double-stops patterns',
  description:'D, A'
},
{
  id:9,
  title:'Double-stops patterns',
  description:'A, E'
}],
},
{
  title:'Scales in extensions',
  description:'This exercise is an introduction to playing tenths. You should try as much as possible to keep the fingers down, especially the first finger, but never hurt yourself! As usual, don\'t forget to keep an eye on the pattern you are playing and the tonality you are in. Also remember to feel which notes are facing each other (fifths) on the two strings.',
  extension:true,
  kind:1,
  exercises:[
{
  id:13,
  title:'Scales on 2 strings',
  description:'G, D'
},
{
  id:14,
  title:'Scales on 2 strings',
  description:'D, A'
},
{
  id:15,
  title:'Scales on 2 strings',
  description:'A, E'
}],
},
  {
  title:'Fingered octaves scales',
  description:'This exercise is very similar to regular octaves, but in extension and with less shifts. Remember which pattern you are playing and the tonality you are in. You will follow the cycle of fifths to cover all the fingerboard.',
  kind:1,
  extension:false,
  exercises:[
{
  id:25,
  title:'Fingered octaves on 3 strings',
  description:'G, D, A'
},
{
  id:26,
  title:'Fingered octaves on 3 strings',
  description:'D, A, E'
},
  ]
},
  {
  title:'Tenths scales',
  description:'',
  kind:1,
  extension:false,
  exercises:[
{
  id:27,
  title:'Tenths on 3 strings',
  description:'G, D, A'
},
{
  id:28,
  title:'Tenths on 3 strings',
  description:'D, A, E'
},
  ]
},
{
  title:'I. Double-stops patterns in extensions',
  description:'These exercises allow you to practice fingered-octaves positions. You will cover every interval in the frame of finger octaces, in every tonality. Try keeping the fingers down as much as possible, to enhance this feeling of frame, but if the intervals are to big, lift your fingers to avoid hurting yourself.',
  extension:true,
  kind:2,
  exercises:[
{
  id:16,
  title:'Patterns in double stops',
  description:'G, D'
},
{
  id:17,
  title:'Patterns in double stops',
  description:'D, A'
},
{
  id:18,
  title:'Patterns in double stops',
  description:'A, E'
}],
},
{
  title:'II. Double-stops patterns in extensions',
  description:'',
  extension:true,
  kind:2,
  exercises:[
{
  id:29,
  title:'Patterns in double stops',
  description:'G, D'
},
{
  id:30,
  title:'Patterns in double stops',
  description:'D, A'
},
{
  id:31,
  title:'Patterns in double stops',
  description:'A, E'
}],
},
]
export default exercises;